import { useLocation } from "react-router-dom";
import "./style.scss";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import userIcon from "../../../assets/svg/dashboard/Icon_User_White.svg";
import mentorIcon from "../../../assets/svg/dashboard/Icon_Mentor_White.svg";
import startupIcon from "../../../assets/svg/dashboard/Icon_Startup_White.svg";
import cohortIcon from "../../../assets/svg/dashboard/Icon_Cohort_White_1.svg";
import MsgIcon from "../../../assets/svg/dashboard/Icon_Message_White.svg";
import logoutIcon from "../../../assets/svg/dashboard/Icon_Logout_White.svg";
import UserDashboard from "../Dashboard/AdminDashboard";
import MentorHome from "../Dashboard/MentorDashboard/MentorHome";
import AdminMentorAction from "../Dashboard/AdminDashboard/AdminMentorAction";
import AllMentorships from "../Dashboard/AdminDashboard/AllMentorships";
import MentorMatchList from "../Dashboard/StartupDashboard/MentorMatchList";
import StartupMyRequest from "../Dashboard/StartupDashboard/StartupMyRequest";
import FeedBack from "../Dashboard/StartupDashboard/FeedBack";
import MentorMessages from "../Dashboard/StartupDashboard/MentorMessages";
import MentorMentorMessages from "../Dashboard/MentorDashboard/MentorMessages";
import AdminAllMessages from "../Dashboard/AdminDashboard/MentorMessages";
import MentorSessions from "../Dashboard/StartupDashboard/MentorSessions";
import MentorFeedback from "../Dashboard/StartupDashboard/MentorFeedback";
import Session from "../Dashboard/StartupDashboard/Session";
import SessionMom from "../Dashboard/StartupDashboard/SessionMom";
import MentorEngagementSummary from "../Dashboard/StartupDashboard/MentorEngagementSummary";
import AllMentorList from "../Dashboard/AdminDashboard/AllMentorList";
import AdminMentorRequest from "../Dashboard/AdminDashboard/AdminMentorRequest";
import MyRequests from "../Dashboard/StartupDashboard/MyRequests";
import MyRequestAction from "../Dashboard/MentorDashboard/MyRequestAction";
import Swal from "sweetalert2";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import Drawer from "./drawer";
import Drawer3 from "./drawer3";
import Drawer4 from "./drawer4";
import AllStartUpList from "../../AdminModule/Dashboard/StartupDashboard/StartupList";
import StartupSubmittedApplications from "../../AdminModule/Dashboard/AdminDashboard/StartupSubmittedApplications";
import Mentorships from "../Dashboard/StartupDashboard/Mentorships";
import StartUpApplication from "../../AdminModule/Dashboard/StartupDashboard/StartUpApplications";
import ViewAllMentorList from "../Dashboard/StartupDashboard/ViewAllMentorList";
import {
  PRODUCTION_MOVE_HIDDEN,
  SET_SELECTED_MENU,
} from "../../common/constants/actionConstants";
import { connect } from "react-redux";
import modalFilters from "../../common/modalFilters";
import MentorMentorships from "../Dashboard/MentorDashboard/Mentorships";
import AllStartUpListMentor from "../../AdminModule/Dashboard/MentorDashboard/AllStartUpList";
import MentorStartupRequest from "../../AdminModule/Dashboard/StartupDashboard/MentorRequest";
import CohortStartupRequest from "../../AdminModule/Dashboard/StartupDashboard/CohortStartupRequest";
import CohortMentorRequest from "../../AdminModule/Dashboard/MentorDashboard/CohortMentorRequest";
import CohortGroupSession from "../../AdminModule/Dashboard/MentorDashboard/CohortGroupSession";
import CohortSessionList from "../Dashboard/MentorDashboard/CohortSessionList";
import AllMentorMentorships from "../Dashboard/AdminDashboard/AllMentorMentorships";
import ActivitySummary from "../Dashboard/AdminDashboard/ActivitySummary";
import CohortApplication from "../Dashboard/AdminDashboard/CohortApplication";
import CohortProgram from "../Dashboard/AdminDashboard/CohortProgram";
import CohortApplicationMentor from "../Dashboard/MentorDashboard/CohortApplications";
import FeatuerUnable from "../../common/FeatuerUnable";
import CohortMentorDashboard from "../Dashboard/MentorDashboard/CohortMentorRequest/cohortMentorDashboard";
import CohortStartupDashboard from "../Dashboard/StartupDashboard/CohortStartupRequest/cohortStartupDashboard";
import CohortForm from "../../CohortForms";
// import Mentorships from "../Dashboard/MentorDashboard/Mentorships";
import CohortStartup from "../Dashboard/MentorDashboard/CohortStartup";
import CohortMentors from "../Dashboard/MentorDashboard/CohortMentors";
import ActivityLowInteraction from "../Dashboard/AdminDashboard/ActivityLowInteraction";
import ActivityPerformace from "../Dashboard/AdminDashboard/ActivityPerformace";
import ActivityNull from "../Dashboard/AdminDashboard/ActivityNull";
import CohortMatchTable from "../Dashboard/AdminDashboard/CohortMatchTable";
import AllStartupMentorMentorships from "../Dashboard/AdminDashboard/AllStartupMentorMentorships";
import ActivityInactivity from "../Dashboard/AdminDashboard/ActivityInactivity";
import CohortMentorships from "../Dashboard/MentorDashboard/CohortMentorships";
import ActivityCohortTotal from "../Dashboard/AdminDashboard/ActivityCohortTotal";
import ActivityCohortDetails from "../Dashboard/AdminDashboard/ActivityCohortDetails";
import CohortMentorshipsStartup from "../Dashboard/StartupDashboard/CohortMentorships";
import CohortAdminMentorships from "../Dashboard/MentorDashboard/CohortAdminMentorships";
import MentorshipClosed from "../Dashboard/AdminDashboard/MentorshipClosed";
import MentorshipScheduled from "../Dashboard/AdminDashboard/MentorshipScheduled";
import MentorshipTotal from "../Dashboard/AdminDashboard/MentorshipTotal";
import MentorshipSession from "../Dashboard/AdminDashboard/MentorshipSession";
import StartupMentorshipHours from "../Dashboard/AdminDashboard/StartupMentorshipHours";
import StartupRequestAccepted from "../Dashboard/AdminDashboard/StartupRequestAccepted";
import StartupRequestSent from "../Dashboard/AdminDashboard/StartupRequestSent";
import CohortCreateSession from "../Dashboard/MentorDashboard/CohortCreateSession";
import CohortRecordingList from "../Dashboard/MentorDashboard/CohortRecordingList";
import AllCohortPrograms from "../../AllCohortPrograms";
import axios from "axios";
import {
  GET_NEW_MESSAGES,
  VIEW_MENTOR_APPLICATION_DATA,
} from "../../common/constants/ApplicationUrl";
import api from "../../common/dependencies/utils/Api";
const newLocal = localStorage.getItem("mentorMenu");
const allmentorlistLocal = localStorage.getItem("allMentorList");
// const toMentorActionLocal = localStorage.getItem("toMentorAction");

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: "80px",
    position: "relative",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      paddingTop: "40px",
    },
  },
}));

const Sidebar = (props) => {
  const classes = useStyles();
  // alert(newLocal)
  let history = useHistory();
  const { selectedMenu, setSelectedMenu } = props;
  const userData = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [applicationStatus, setApplicationStatus] = useState();
  useEffect(() => {
    if(selectedMenu == "")
    {
      setSelectedMenu("adminMenu")
    }
    return () => {
      setSelectedMenu("");
    }
  }, [])
  
  const logoutClick = () => {
    localStorage.removeItem("SavedLoggedInData");
    localStorage.removeItem("loggedIn");
    toast.success("User Logged Out", {
      position: "top-right",
      autoClose: 2000,
    });
    // history.push(`/`);
    setTimeout(function () {
      history.push(`/login`);
    }, 3000);
  };

  useEffect(() => {
    if (localStorage.getItem("loggedIn") === "true") {
      const params = {
        id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      };
      api
        .POST(`${VIEW_MENTOR_APPLICATION_DATA}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            if (response.data.data) {
              const responseData = response.data.data;
              if (responseData.role == "Mentor") {
                // alert(LoginFormData?.applicationStatus)
                setApplicationStatus(responseData.applicationStatus);
              }
            } else {
              setApplicationStatus(LoginFormData?.applicationStatus);
            }
          }
        })
        .catch((e) => {});
    } else {
      history.push("/login");
    }
  }, []);
  const swalPopUp = (text) => {
    Swal.fire({
      title: `Please stay tuned, this function will be enabled shortly after the launch of ${text} onboarding process.`,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  };

  const [LoginFormData, setLoginFormData] = useState();
  const [userRole, setUserRole] = useState();
  const [mentorMatchlistId, setMentorMatchlistId] = useState();
  const [startUpIdList, setStartUpIdList] = useState();
  const [newMessages, setNewMessages] = useState();

  const getNewMessages = () => {
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // axios({
    //   url: GET_NEW_MESSAGES,
    //   method: "post",
    //   data: {
    //     id: value?.id,
    //   },
    // })
    api
      .POST(GET_NEW_MESSAGES, {
        id: value?.id,
      })
      .then((res) => {
        setNewMessages(res.data?.data?.unread);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getNewMessages();
  }, []);

  useEffect(() => {
    // alert(PRODUCTION_MOVE_HIDDEN)
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let LoginData = JSON.parse(value);

      setLoginFormData(LoginData);
      setUserRole(LoginData.role);
      if (LoginFormData?.role == "Admin") {
        // alert(localStorage.getItem("mentorMenu"))
        if (localStorage.getItem("mentorMenu") === "mentorMenu") {
          setSelectedMenu("mentorMenu");
        } else if (localStorage.getItem("allMentorList") === "allMentorList") {
          setSelectedMenu("allMentorList");
        } else if (
          localStorage.getItem("mentorRequests") === "mentorRequests"
        ) {
          setSelectedMenu("mentorRequests");
        } else if (
          localStorage.getItem("allMentorsMentorship") ===
          "allMentorsMentorship"
        ) {
          setSelectedMenu("allMentorsMentorship");
        } else if (
          localStorage.getItem("allStartupList") === "allStartupList"
        ) {
          setSelectedMenu("allStartupList");
        } else if (
          localStorage.getItem("startUpApplications") === "startUpApplications"
        ) {
          setSelectedMenu("startUpApplications");
        } else if (
          localStorage.getItem("mentorMatchList") === "mentorMatchList"
        ) {
          setSelectedMenu("mentorMatchList");
        } else if (localStorage.getItem("mentorships") === "mentorships") {
          setSelectedMenu("mentorships");
        } else if (
          localStorage.getItem("allMentorships") === "allMentorships"
        ) {
          setSelectedMenu("allMentorships");
        } else if (
          localStorage.getItem("allMentorsMentorship") ===
          "allMentorsMentorship"
        ) {
          setSelectedMenu("allMentorsMentorship");
        } else if (
          localStorage.getItem("activitySummary") === "activitySummary"
        ) {
          setSelectedMenu("activitySummary");
        } else if (
          localStorage.getItem("cohortApplication") === "cohortApplication"
        ) {
          setSelectedMenu("cohortApplication");
        } else if (
          localStorage.getItem("mentorshipClosed") === "mentorshipClosed"
        ) {
          setSelectedMenu("mentorshipClosed");
        } else if (
          localStorage.getItem("mentorshipScheduled") === "mentorshipScheduled"
        ) {
          setSelectedMenu("mentorshipScheduled");
        } else if (
          localStorage.getItem("mentorshipTotal") === "mentorshipTotal"
        ) {
          setSelectedMenu("mentorshipTotal");
        } else if (
          localStorage.getItem("mentorshipSession") === "mentorshipSession"
        ) {
          setSelectedMenu("mentorshipSession");
        } else if (localStorage.getItem("cohortProgram") === "cohortProgram") {
          setSelectedMenu("cohortProgram");
        } else if (
          localStorage.getItem("startupMentorshipHours") ===
          "startupMentorshipHours"
        ) {
          setSelectedMenu("startupMentorshipHours");
        } else if (
          localStorage.getItem("startupRequestAccepted") ===
          "startupRequestAccepted"
        ) {
          setSelectedMenu("startupRequestAccepted");
        } else if (
          localStorage.getItem("startupRequestSent") === "startupRequestSent"
        ) {
          setSelectedMenu("startupRequestSent");
        } else if (
          localStorage.getItem("activitySummary2") === "activitySummary2"
        ) {
          setSelectedMenu("activitySummary2");
        } else if (
          localStorage.getItem("activitySummary3") === "activitySummary3"
        ) {
          setSelectedMenu("activitySummary3");
        } else if (
          localStorage.getItem("activitySummary4") === "activitySummary4"
        ) {
          setSelectedMenu("activitySummary4");
        } else if (
          localStorage.getItem("activitySummary5") === "activitySummary5"
        ) {
          setSelectedMenu("activitySummary5");
        } else if (
          localStorage.getItem("activityCohortTotal") === "activityCohortTotal"
        ) {
          setSelectedMenu("activityCohortTotal");
        } else if (
          localStorage.getItem("activityCohortDetails") ===
          "activityCohortDetails"
        ) {
          setSelectedMenu("activityCohortDetails");
        } else if (
          localStorage.getItem("sessionRecording") === "sessionRecording"
        ) {
          setSelectedMenu("sessionRecording");
        } else if (
          localStorage.getItem("CohortSessionList") === "CohortSessionList"
        ) {
          setSelectedMenu("CohortSessionList");
        } else if (
          localStorage.getItem("startupMentorAllMentorships") ===
          "startupMentorAllMentorships"
        ) {
          setSelectedMenu("startupMentorAllMentorships");
        } else if (
          localStorage.getItem("MyJoinedCohortDashboard") ===
          "MyJoinedCohortDashboard"
        ) {
          setSelectedMenu("MyJoinedCohortDashboard");
        } else if (
          localStorage.getItem("MyCreatedCohortDashboard") ===
          "MyCreatedCohortDashboard"
        ) {
          setSelectedMenu("MyCreatedCohortDashboard");
        } else if (
          localStorage.getItem("MyCohortMentorDashboard") ===
          "MyCohortMentorDashboard"
        ) {
          setSelectedMenu("MyCohortMentorDashboard");
        } else if (
          localStorage.getItem("allCohortPrograms") === "allCohortPrograms"
        ) {
          setSelectedMenu("MyCohortMentorDashboard");
        } else {
          setSelectedMenu("adminMenu");
        }
      } else if (LoginFormData?.role == "Mentor") {
        if (
          localStorage.getItem("mentorDashboardHome") === "mentorDashboardHome"
        ) {
          setSelectedMenu("adminMenu");
        } else if (
          localStorage.getItem("CohortGroupSession") === "CohortGroupSession"
        ) {
          setSelectedMenu("CohortGroupSession");
        } else if (
          localStorage.getItem("CohortSessionList") === "CohortSessionList"
        ) {
          setSelectedMenu("CohortSessionList");
        } else if (
          localStorage.getItem("cohortMatchTable") === "cohortMatchTable"
        ) {
          setSelectedMenu("cohortMatchTable");
        } else if (localStorage.getItem("cohortProgram") === "cohortProgram") {
          setSelectedMenu("cohortProgram");
        } else if (
          localStorage.getItem("cohortApplicationMentor") ===
          "cohortApplicationMentor"
        ) {
          setSelectedMenu("cohortApplicationMentor");
        } else if (
          localStorage.getItem("mentorMentorships") === "mentorMentorships"
        ) {
          setSelectedMenu("mentorMentorships");
        } else if (localStorage.getItem("myrequestMenu") === "myrequestMenu") {
          setSelectedMenu("myrequestMenu");
        } else if (
          localStorage.getItem("startupListMentor") === "startupListMentor"
        ) {
          setSelectedMenu("startupListMentor");
        } else if (localStorage.getItem("cohortStartup") === "cohortStartup") {
          setSelectedMenu("cohortStartup");
        } else if (localStorage.getItem("CohortForm") === "CohortForm") {
          setSelectedMenu("CohortForm");
        } else if (localStorage.getItem("cohortMentors") === "cohortMentors") {
          setSelectedMenu("cohortMentors");
        } else if (
          localStorage.getItem("cohortAdminMentorships") ===
          "cohortAdminMentorships"
        ) {
          setSelectedMenu("cohortAdminMentorships");
        } else if (
          localStorage.getItem("sessionRecording") === "sessionRecording"
        ) {
          setSelectedMenu("sessionRecording");
        } else if (
          localStorage.getItem("MyCohortMentorDashboard") ===
          "MyCohortMentorDashboard"
        ) {
          setSelectedMenu("MyCohortMentorDashboard");
        } else if (
          localStorage.getItem("CohortMentorRequest") === "CohortMentorRequest"
        ) {
          setSelectedMenu("CohortMentorRequest");
        } else if (
          localStorage.getItem("allCohortPrograms") === "allCohortPrograms"
        ) {
          setSelectedMenu("allCohortPrograms");
        } else if (
          localStorage.getItem("CohortMentorRequest") === "CohortMentorRequest"
        ) {
          setSelectedMenu("CohortMentorRequest");
        } else if (
          localStorage.getItem("cohortMatchTable") === "cohortMatchTable"
        ) {
        } else if (
          localStorage.getItem("cohortInvitation") === "cohortInvitation"
        ) {
          setSelectedMenu("cohortInvitation");
        }
      } else if (LoginFormData?.role == "Startup") {
        if (
          localStorage.getItem("mentorStartupRequest") ===
          "mentorStartupRequest"
        ) {
          setSelectedMenu("mentorStartupRequest");
        } else if (
          localStorage.getItem("cohortMentorshipsStartup") ===
          "cohortMentorshipsStartup"
        ) {
          setSelectedMenu("cohortMentorshipsStartup");
        } else if (
          localStorage.getItem("startupAllMentorList") ===
          "startupAllMentorList"
        ) {
          setSelectedMenu("startupAllMentorList");
        } else if (
          localStorage.getItem("CohortStartupRequest") ===
          "CohortStartupRequest"
        ) {
          setSelectedMenu("CohortStartupRequest");
        } else if (
          localStorage.getItem("startUpRequests") === "startUpRequests"
        ) {
          setSelectedMenu("startUpRequests");
        } else if (localStorage.getItem("myRequests") === "myRequests") {
          setSelectedMenu("myRequests");
        } else if (
          localStorage.getItem("sessionRecording") === "sessionRecording"
        ) {
          setSelectedMenu("sessionRecording");
        } else if (
          localStorage.getItem("MyCohortStartupDashboard") ===
          "MyCohortStartupDashboard"
        ) {
          setSelectedMenu("MyCohortStartupDashboard");
        } else if (
          localStorage.getItem("cohortApplicationMentor") ===
          "cohortApplicationMentor"
        ) {
          setSelectedMenu("cohortApplicationMentor");
        } else if (
          localStorage.getItem("allCohortPrograms") === "allCohortPrograms"
        ) {
          setSelectedMenu("allCohortPrograms");
        } else setSelectedMenu("startupMyRequest");
      }
    } catch (error) {}

    setTimeout(() => {
      // localStorage.removeItem("mentorMenu");
      // localStorage.removeItem("allMentorships");
      // localStorage.removeItem("allMentorList");
      // localStorage.removeItem("allStartupList");
      localStorage.removeItem("showPending");
      localStorage.removeItem("mentorDashboardHome");
      // localStorage.removeItem("startUpApplications");
      // localStorage.removeItem("mentorStartupRequest");
      // localStorage.removeItem("cohortProgram");
      // localStorage.removeItem("cohortApplication");
      localStorage.removeItem("toMentorAction");
      // localStorage.removeItem("cohortStartup");
      // localStorage.removeItem("cohortMentors");
      localStorage.removeItem("mentorRequests");
      localStorage.removeItem("activitySummary");
      localStorage.removeItem("activitySummary2");
      localStorage.removeItem("activitySummary3");
      localStorage.removeItem("activitySummary4");
      localStorage.removeItem("activitySummary5");
      localStorage.removeItem("activityCohortTotal");
      localStorage.removeItem("activityCohortDetails");
      localStorage.removeItem("mentorshipClosed");
      localStorage.removeItem("mentorshipScheduled");
      localStorage.removeItem("mentorshipTotal");
      localStorage.removeItem("mentorshipSession");
      localStorage.removeItem("startupMentorshipHours");
      localStorage.removeItem("startupRequestAccepted");
      localStorage.removeItem("startupRequestSent");
      localStorage.removeItem("MyCohortStartupDashboard");
      localStorage.removeItem("MyCohortMentorDashboard");
      localStorage.removeItem("MyCreatedCohortDashboard");
      localStorage.removeItem("MyJoinedCohortDashboard");
      localStorage.removeItem("allCohortPrograms");
      // localStorage.removeItem("CohortForm");
      // localStorage.removeItem("cohortMatchTable");
    }, 1000);
  }, [userRole]);
  return (
    <div className={classes.root}>
      {LoginFormData?.role == "Admin" ? (
        <Drawer
          logoutClick={logoutClick}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
          newMessages={newMessages}
        />
      ) : (
        ""
      )}
      {LoginFormData?.role == "Mentor" ? (
        <Drawer4
          logoutClick={logoutClick}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
          newMessages={newMessages}
          getNewMessages={getNewMessages}
        />
      ) : (
        ""
      )}
      {LoginFormData?.role == "Startup" ? (
        <Drawer3
          logoutClick={logoutClick}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
          newMessages={newMessages}
          getNewMessages={getNewMessages}
        />
      ) : (
        ""
      )}
      {/* <Drawer logoutClick={logoutClick} selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} /> */}
      <div style={{ background: "#fff" }}>
        <div>
          {LoginFormData &&
          LoginFormData?.role == "Admin" &&
          selectedMenu == "adminMenu" ? (
            <UserDashboard setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu == "mentorMenu" ? (
            <AdminMentorAction />
          ) : selectedMenu == "mentorRequests" ? (
            <AdminMentorRequest />
          ) : selectedMenu == "allMentorList" ? (
            <AllMentorList />
          ) : selectedMenu == "allStartupList" ? (
            <AllStartUpList
              setStartUpIdList={setStartUpIdList}
              setSelectedMenu={setSelectedMenu}
              startUpIdList={startUpIdList}
            />
          ) : selectedMenu == "startUpApplications" ? (
            <StartUpApplication
              mentorMatchlistId={mentorMatchlistId}
              setMentorMatchlistId={setMentorMatchlistId}
              setSelectedMenu={setSelectedMenu}
            />
          ) : selectedMenu == "startupSubmittedApplications" ? (
            <StartupSubmittedApplications
              setStartUpIdList={setStartUpIdList}
              setSelectedMenu={setSelectedMenu}
              startUpIdList={startUpIdList}
            />
          ) : selectedMenu == "mentorMatchList" &&
            LoginFormData?.role == "Admin" ? (
            <MentorMatchList mentorMatchlistId={mentorMatchlistId} />
          ) : selectedMenu == "mentorships" &&
            LoginFormData?.role == "Admin" ? (
            <Mentorships startUpIdList={startUpIdList} />
          ) : selectedMenu === "allMentorships" ? (
            <AllMentorships />
          ) : selectedMenu === "allMentorsMentorship" ? (
            <AllMentorMentorships />
          ) : selectedMenu === "activitySummary" ? (
            <ActivitySummary />
          ) : selectedMenu === "cohortProgram" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortProgram setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "cohortApplication" ? (
            <CohortApplication setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activitySummary2" ? (
            <ActivityLowInteraction setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activitySummary3" ? (
            <ActivityPerformace setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activitySummary4" ? (
            <ActivityNull setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activitySummary5" ? (
            <ActivityInactivity setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activityCohortTotal" ? (
            <ActivityCohortTotal setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "activityCohortDetails" ? (
            <ActivityCohortDetails setSelectedMenu={setSelectedMenu} />
          ) : selectedMenu === "adminMessage" ? (
            <AdminAllMessages />
          ) : selectedMenu === "sessionRecording" ? (
            <CohortRecordingList />
          ) : selectedMenu === "startupMentorAllMentorships" ? (
            <AllStartupMentorMentorships />
          ) : selectedMenu === "mentorshipClosed" ? (
            <MentorshipClosed />
          ) : selectedMenu === "mentorshipScheduled" ? (
            <MentorshipScheduled />
          ) : selectedMenu === "mentorshipTotal" ? (
            <MentorshipTotal />
          ) : selectedMenu === "mentorshipSession" ? (
            <MentorshipSession />
          ) : selectedMenu === "CohortSessionList" ? (
            <CohortSessionList />
          ) 
          // : selectedMenu === "allCohortPrograms" ? (
          //   <AllCohortPrograms />
          // ) 
          :
           (
            ""
          )}
          {LoginFormData &&
          LoginFormData?.role == "Mentor" &&
          selectedMenu == "adminMenu" ? (
            <MentorHome
              loginData={LoginFormData}
              setSelectedMenu={setSelectedMenu}
            />
          ) : selectedMenu === "mentorMentorMessage" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : JSON.parse(localStorage.getItem("SavedLoggedInData"))
                ?.applicationStatus === "VERIFIED" ? (
              <MentorMentorMessages />
            ) : (
              <FeatuerUnable />
            )
          ) : selectedMenu === "mentorSession" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <MentorSessions />
            )
          ) : selectedMenu == "myrequestMenu" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : JSON.parse(localStorage.getItem("SavedLoggedInData"))
                ?.applicationStatus === "VERIFIED" ? (
              <MyRequestAction setSelectedMenu={setSelectedMenu} />
            ) : (
              <FeatuerUnable />
            )
          ) : selectedMenu === "mentorMentorships" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : JSON.parse(localStorage.getItem("SavedLoggedInData"))
                ?.applicationStatus === "VERIFIED" ? (
              <MentorMentorships />
            ) : (
              <FeatuerUnable />
            )
          ) : selectedMenu === "allCohortPrograms" ? (
            <AllCohortPrograms />
          ) : selectedMenu == "CohortGroupSession" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortGroupSession setSelectedMenu={setSelectedMenu} />
            )
          ) : // : selectedMenu == "CohortSessionList" ? (
          //   LoginFormData?.applicationStatus == "DRAFT" ||
          //   LoginFormData?.applicationStatus == "SUBMITTED" ||
          //   LoginFormData?.applicationStatus == "UPDATEDINFO" ||
          //   LoginFormData?.applicationStatus == "REQUESTINFO" ? (
          //     <MentorHome
          //       loginData={LoginFormData}
          //       setSelectedMenu={setSelectedMenu}
          //     />
          //   ) : (
          //     <CohortSessionList setSelectedMenu={setSelectedMenu} />
          //   )
          // )
          selectedMenu == "CohortMentorRequest" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentorRequest setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "MyJoinedCohortDashboard" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentorDashboard visibilityStatus="joinedCohorts" />
            )
          ) : selectedMenu === "MyCreatedCohortDashboard" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentorDashboard visibilityStatus="createCohorts" />
            )
          ) : selectedMenu === "MyCohortMentorDashboard" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentorDashboard visibilityStatus="allCohorts" />
            )
          ) : selectedMenu === "cohortStartup" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortStartup setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "CohortForm" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortForm setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "cohortMentors" &&
            selectedMenu !== "cohortStartup" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentors setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "cohortApplicationMentor" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortApplicationMentor setSelectedMenu={setSelectedMenu} />
            )
          ) : // selectedMenu === "cohortProgram" && userRole ==="Mentor" ? (
          //             <CohortProgram setSelectedMenu={setSelectedMenu}/>)
          //             :
          selectedMenu === "startupListMentor" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : JSON.parse(localStorage.getItem("SavedLoggedInData"))
                ?.applicationStatus === "VERIFIED" ? (
              <AllStartUpListMentor />
            ) : (
              <FeatuerUnable />
            )
          ) : selectedMenu === "cohortMatchTable" ? (
            applicationStatus == "DRAFT" ||
            applicationStatus == "SUBMITTED" ||
            applicationStatus == "UPDATEDINFO" ||
            applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMatchTable setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "cohortMentorships" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortMentorships setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu === "cohortAdminMentorships" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortAdminMentorships />
            )
          ) : selectedMenu === "startupMentorshipHours" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <StartupMentorshipHours />
            )
          ) : selectedMenu === "startupMentorshipOngoing" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <StartupRequestAccepted />
            )
          ) : // <StartupMentorshipOngoing />
          selectedMenu === "startupRequestAccepted" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <StartupRequestAccepted />
            )
          ) : selectedMenu === "allCohortPrograms" ? (
            <AllCohortPrograms />
          ) : selectedMenu === "startupRequestSent" ? (
            LoginFormData?.applicationStatus == "DRAFT" ||
            LoginFormData?.applicationStatus == "SUBMITTED" ||
            LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            LoginFormData?.applicationStatus == "REQUESTINFO" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <StartupRequestSent />
            )
          ) : selectedMenu === "cohortInvitation" ? (
            (LoginFormData &&
              LoginFormData?.role == "Startup" &&
              applicationStatus == "PENDING") ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <>
                <CohortCreateSession />
              </>
            )
          ) : (
            // (
            //   LoginFormData?.applicationStatus == "DRAFT" ||
            //   LoginFormData?.applicationStatus == "SUBMITTED" ||
            //   LoginFormData?.applicationStatus == "UPDATEDINFO" ||
            //   LoginFormData?.applicationStatus == "REQUESTINFO" ? (
            //   <MentorHome
            //     loginData={LoginFormData}
            //     setSelectedMenu={setSelectedMenu}
            //   />
            // ) :
            //  (
            //   <CohortCreateSession />
            // )
            // )
            ""
          )}

          {LoginFormData &&
          LoginFormData?.role == "Startup" &&
          selectedMenu == "mentorMatchList" ? (
            applicationStatus == "DRAFT" ? (
              setSelectedMenu("startupMyRequest")
            ) : (
              <MentorMatchList
                mentorMatchlistId={mentorMatchlistId}
                setMentorMatchlistId={setMentorMatchlistId}
                setSelectedMenu={setSelectedMenu}
              />
            )
          ) : selectedMenu == "startupMyRequest" ? (
            <StartupMyRequest
              setSelectedMenu={setSelectedMenu}
              setStartUpIdList={setStartUpIdList}
              startUpIdList={startUpIdList}
            />
          ) : selectedMenu == "mentorMessages" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <MentorMessages />
            )
          ) : selectedMenu === "MyCohortStartupDashboard" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <MentorHome
                loginData={LoginFormData}
                setSelectedMenu={setSelectedMenu}
              />
            ) : (
              <CohortStartupDashboard />
            )
          ) : selectedMenu == "mentorSessions" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <MentorSessions />
            )
          ) : selectedMenu == "myRequests" ? (
            applicationStatus === "SUBMITTED" ? (
              <MyRequests
                mentorMatchlistId={mentorMatchlistId}
                setMentorMatchlistId={setMentorMatchlistId}
                setSelectedMenu={setSelectedMenu}
              />
            ) : applicationStatus == "PENDING" ||
              applicationStatus == "REJECTED" ||
              applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <MyRequests
                mentorMatchlistId={mentorMatchlistId}
                setMentorMatchlistId={setMentorMatchlistId}
                setSelectedMenu={setSelectedMenu}
              />
            )
          ) : selectedMenu == "feedBack" ? (
            <FeedBack />
          ) : selectedMenu == "mentorFeedBack" ? (
            <MentorFeedback />
          ) : selectedMenu == "session" ? (
            <Session />
          ) : selectedMenu == "sessionMom" ? (
            <SessionMom />
          ) : selectedMenu == "mentorEngagementSummary" ? (
            <MentorEngagementSummary />
          ) : selectedMenu == "mentorships" &&
            LoginFormData?.role !== "Admin" ? (
            (LoginFormData?.role == "Startup" &&
              applicationStatus == "PENDING") ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <Mentorships />
            )
          ) : selectedMenu == "startUpRequests" ? (
            <Mentorships />
          ) : selectedMenu == "startupAllMentorList" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <ViewAllMentorList setSelectedMenu={setSelectedMenu} />
            )
          ) : selectedMenu == "mentorStartupRequest" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <>
                {/* {setSelectedMenu("mentorStartupRequest")} */}
                <MentorStartupRequest setSelectedMenu={setSelectedMenu} />
              </>
            )
          ) : selectedMenu == "CohortStartupRequest" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <>
                <CohortStartupRequest setSelectedMenu={setSelectedMenu} />
              </>
            )
          ) : selectedMenu === "cohortMentorshipsStartup" ? (
            applicationStatus == "PENDING" ||
            applicationStatus == "REJECTED" ||
            applicationStatus == "DRAFT" ? (
              <StartupMyRequest />
            ) : (
              <CohortMentorshipsStartup />
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedMenu: state.StartUpReducer.selectedMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedMenu: (payload) => dispatch({ type: SET_SELECTED_MENU, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
